<template>
  <div class="consum_details_holder">
    <div class="consum_details_spacer"></div>
    <div class="info_line">
      <div class="info_label">Valoare:</div>
      <div class="info_value">
        <div>{{ Number(templateData.price ?? 0).toFixed(2) }} Ron</div>
        <div class="cost_for_ha">({{ Number((parseFloat(templateData.price) / parseFloat(parcel_surface ?? 0))).toFixed(2) }} Ron/ha)</div>
      </div>
    </div>
    <div class="info_line">
      <div class="info_label">Cantitate:</div>
      <div class="info_value">{{ templateData.quantity | getLocalFormattedQuantity }} {{ templateData.measure_unit_symbol }}</div>
    </div>
    <div class="info_line">
      <div class="info_label">Observații:</div>
      <div class="info_value">{{ templateData.notes }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductionDetails",
  props: {
    templateData: {
      type: Object,
      default: {},
    },
    parcel_surface: {
      type: String,
      default: "0",
    },
  },
};
</script>
